import DoNotRentModal from './DoNotRentModal';

export default DoNotRentModal;
